module.exports = __webpack_public_path__ + "img/About.c2e53a02.png";